import React, { Component } from 'react';
import { Button, Select,DatePicker,Input } from 'antd';
//import { StatisticsList } from '../../../constants';
import SelectBa from '../../../components/SelectBa';
import moment from 'moment';
import {defaultDate} from "../../../../../common/jsLibs";

const { Option } = Select;
const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;
class Filter extends Component {
    search = () => {
        this.props.search();
    }

    handleChange = (value, key) => {
        const { searchParams, onChange } = this.props;
        switch (key) {
            case 'customerBaName': {
                const { lastLeaf, checkedKeys, expandedKeys } = value;
                searchParams.lastLeaf = lastLeaf;
                searchParams.checkedKeys = checkedKeys;
                searchParams.expandedKeys = expandedKeys;
                searchParams.customerBaNameIds = (lastLeaf || []).map(i => i.id).join(',');
                searchParams.customerBaNameNames = (lastLeaf || []).map(i => i.title).join(',');
                onChange(searchParams);
                break;
            }
            default:
                searchParams[key] = value;
                onChange(searchParams);
                break;
        }
    }

    render () {
        const { searchParams } = this.props;
        const defaultDateObj = defaultDate();
        const{beginDateDefault,endDateDefault}=defaultDateObj;
        const {
            beginDate = beginDateDefault,
            endDate = endDateDefault,
            lastLeaf, checkedKeys, expandedKeys
        } = searchParams;
        const StatisticsList = [
            { label: '已开票总金额', value: 'grossAmount' },
            { label: '确认可请款金额', value: 'canApplyAmount' },
            { label: '延时不可请款金额', value: 'canNotApplyAmount' },
            { label: '预计milestone可请款金额', value: 'milestoneAmount' },
        ]
        const statisticsOption = StatisticsList.map(i => <Option key={i.value}>{i.label}</Option>);
        return (
            <div style={{ marginBottom: 16 }}>
                <div className="search-bar">
                <div className="search-item">
                        <label htmlFor="" className="ui-label">时间</label>
                        <MonthPicker
                            format={monthFormat}
                            style={{width: 100}}
                            value={beginDate ? moment(beginDate) : null}
                            // disabledDate={this.disabledDate}
                            placeholder="选择月份"
                            allowClear={false}
                            onChange={(date, dateString) => this.handleChange(dateString, 'beginDate')}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">至</label>
                        <MonthPicker
                            format={monthFormat}
                            style={{width: 100}}
                            value={endDate ? moment(endDate) : null}
                            placeholder="选择月份"
                            allowClear={false}
                            onChange={(date, dateString) => this.handleChange(dateString, 'endDate')}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">排序维度</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 150}}
                            value={searchParams.sort}
                            onChange={value => this.handleChange(value, 'sort')}
                        >
                            {statisticsOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <Button type="primary" onClick={this.search}>统计</Button>
                    </div>
                </div>
                <SelectBa ref={el => this.selectBaRef = el}
                  lastLeaf={lastLeaf}
                  checkedKeys={checkedKeys}
                  expandedKeys={expandedKeys}
                  onChange={args => this.handleChange(args, 'customerBaName')}
                />
            </div>
        );
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestAndReturnedSheet/RequestSheet/HistogramBrokenLine/Filter.js